import React from 'react';
import styled from 'styled-components';
import { Flex } from './Flex';
import { SmallCloseIcon } from '../icons/SmallCloseIcon';

const StyledNotificationBox = styled(Flex).attrs({
    width: "320px",
})`
    position: relative;
    box-shadow: 0px 4px 20px rgba(87, 124, 255, 0.15);
    // opacity: .9;

    transition: .3s ease;
    animation: toast-in-right .7s;

    @keyframes toast-in-right {
        from {
            transform: translateX(100%);
        }
        to {
            transform: translateX(0);
        }
    }
`;

const StyledNotificationContent = styled(Flex).attrs({
    flex: 1,
    direction: "column",
    background: "#FFFFFF",
    padding: { left: "12px", top: "11px", right: "20px", bottom: "14px" }
})`
    min-height: 44px;
    border-radius: 0px 8px 8px 0px;
`;

const StyledMark = styled.span`
    background: ${({color}) => color};
    width: 10px;
    border-radius: 8px 0px 0px 8px;
`;

const StyledCloseIcon = styled(SmallCloseIcon)`
    position: absolute;
    top: 13px;
    right: 13px;
`;

export const NotificationBox = ({ onClose, ...props }) => (
    <StyledNotificationBox name="notification">
        <StyledCloseIcon onClick={() => onClose()} />
        <StyledMark color={props.color} />
        <StyledNotificationContent {...props} />
    </StyledNotificationBox>
);